import { motion } from "framer-motion";
import * as BsIcons from "react-icons/bs";
import ScrollBg from "../assets/scroll.png";

const spinTransition = {
  repeat: Infinity,
  ease: "linear",
  duration: 5,
};

const bounceTransition = {
  repeat: Infinity,
  ease: "linear",
  duration: 1,
};

const Scroll = () => {
  const handleScroll = () => {
    document.getElementById("intro").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.div
      className="scroll-btn"
      initial={{ opacity: 0, z: 100 }}
      animate={{ opacity: 1, z: 0 }}
      exit={{ opacity: 0, z: -100 }}
      transition={{ duration: 0.5, delay: 1.5 }}
    >
      <motion.div
        className="scroll-bg"
        animate={{ rotate: 360 }}
        transition={spinTransition}
        style={{
          backgroundImage: `url(${ScrollBg})`,
        }}
        onClick={handleScroll}
      />
      <motion.div
        className="scroll-text"
        animate={{ transform: "translateY(10px)" }}
        transition={bounceTransition}
      >
        <p>Scroll</p>
        <BsIcons.BsChevronDown />
      </motion.div>
    </motion.div>
  );
};

export default Scroll;
